import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { AuthenticationService } from './authentication/authentication.service';
import { LoggingService } from './logging/logging.service';

@Injectable()
export class TagsService {

  constructor(
    private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
  ) { }
  search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/tags/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
  }
  
  delete(name: string): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/tags/delete/${name}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

}



// WEBPACK FOOTER //
// ./src/app/services/tags.service.ts